<template>
  <div class="box-shadow my-3 details">
    <div class="card-image">
      <figure class="image is-4by3">
        <img
          class="img-fluid"
          :src="product.image ? product.image.url : defaultImage"
          alt="Placeholder image"
        />
      </figure>
    </div>
    <div class="card-content">
      <div class="p-3">
        <div class>
          <router-link
            class=""
            :to="{
              path: '/product-detail',
              name: 'product-detail-component',
              params: {
                id: product.id,
                title: product.name,
                price: product.price,
                rating: product.ratings,
                reviews: product.reviews,
                isAddedBtn: product.isAddedBtn,
              },
            }"
          >
            <h1 class="title">{{ product.name }}</h1>
          </router-link>
        </div>

        <div class="clearfix">
          <p>{{ product.description }}</p>
          <div class="float-left">
            <i v-if="product.ratings === 1" class="fa fa-star"></i>
            <i v-if="product.ratings === 2" class="fa fa-star"></i>
            <i v-if="product.ratings === 2" class="fa fa-star"></i>
            <i v-if="product.ratings === 3" class="fa fa-star"></i>
            <i v-if="product.ratings === 3" class="fa fa-star"></i>
            <i v-if="product.ratings === 3" class="fa fa-star"></i>
            <i v-if="product.ratings === 4" class="fa fa-star"></i>
            <i v-if="product.ratings === 4" class="fa fa-star"></i>
            <i v-if="product.ratings === 4" class="fa fa-star"></i>
            <i v-if="product.ratings === 4" class="fa fa-star"></i>
            <i v-if="product.ratings === 5" class="fa fa-star"></i>
            <i v-if="product.ratings === 5" class="fa fa-star"></i>
            <i v-if="product.ratings === 5" class="fa fa-star"></i>
            <i v-if="product.ratings === 5" class="fa fa-star"></i>
            <i v-if="product.ratings === 5" class="fa fa-star"></i>
            <span>{{
              product.reviews > 0 ? `${product.reviews} نظر` : "بدون نظر"
            }}</span>
          </div>
          <span class="float-right">
            <span class="price">
              <strong>{{ formatNumber(product.price) }} تومان</strong>
            </span>
          </span>
        </div>
      </div>

      <div class="btn-actions p-1 px-2">
        <div class="card-footer-item">
          <div
            class="buttons d-flex justify-content-between align-items-center"
          >
            <!-- <button
              class="btn btn-danger rounded-pill"
              v-if="!findInCart(product.id)"
              @click="addToCart(product)"
            >{{ addToCartLabel }}</button>
            <button
              class="btn btn-outline-danger rounded-pill"
              v-else
              @click="removeFromCart(product.id, false)"
            >{{ removeFromCartLabel }}</button>-->

            <count-ctrl :product="product" :cartItem="findInCart(product.id)" />

            <span
              class="btn"
              :title="removeFromFavouriteLabel"
              v-show="product.isFavourite"
              @click.stop="removeFromFavourite(product.id)"
            >
              <span class="icon is-small">
                <i class="fas fa-heart"></i>
              </span>
            </span>
            <span
              class="btn"
              :title="addToFavouriteLabel"
              v-show="!product.isFavourite"
              @click.stop="saveToFavorite(product.id)"
            >
              <span class="icon is-small">
                <i class="far fa-heart"></i>
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CountCtrl from "@/components/CountCtrl";

export default {
  name: "products-component",
  props: ["product"],

  components: {
    "count-ctrl": CountCtrl,
  },

  data() {
    return {
      addToCartLabel: "افزودن به سبد",
      removeFromCartLabel: "حذف از سبد",
      viewDetailsLabel: "جزئیات",
      addToFavouriteLabel: "مورد علاقه",
      removeFromFavouriteLabel: "حذف از علاقه مندی",
      defaultImage: "https://bulma.io/images/placeholders/1280x960.png",

      selected: 1,
      options: [
        { value: 1, text: "1" },
        { value: 2, text: "2" },
        { value: 3, text: "3" },
        { value: 4, text: "4" },
        { value: 5, text: "5" },
        { value: 6, text: "6" },
        { value: 7, text: "7" },
        { value: 8, text: "8" },
        { value: 9, text: "9" },
        { value: 10, text: "10" },
      ],
    };
  },

  mounted() {
    //
  },

  computed: {
    ...mapGetters({
      isUserLogged: "isUserLoggedIn",
      cartItems: "cartItems",
    }),
  },

  methods: {
    addToCart(product) {
      this.$store.dispatch("addToCart", product);
    },

    removeFromCart(id) {
      this.$store.dispatch("removeFromCart", id);
    },

    saveToFavorite(id) {
      //let isUserLogged = this.$store.state.user.isLoggedIn

      if (this.isUserLogged) {
        this.$store.commit("addToFavourite", id);
      } else {
        this.$store.commit("showLoginModal", true);
      }
    },

    removeFromFavourite(id) {
      this.$store.commit("removeFromFavourite", id);
    },

    onSelectQuantity(product) {
      this.$store.dispatch("updateItem", product);
    },

    findInCart(id) {
      return this.cartItems.find((item) => item.product_id === id);
    },
  },
};
</script>

<style lang="scss" scoped>
.details {
  z-index: 1;
 /* transition: transform 0.2s; /* Animation */

  &:hover {
    border: none;
    /* transform: scale(1.05); */
  }
}
.buttons .btn,
.buttons .select {
  z-index: 200;
}

.title {
  font-size: 1.2rem;
}
</style>


